module.exports = __webpack_public_path__ + "8f2fd5c6a31a0b0a9c384ab1bb489e86.png";


//////////////////
// WEBPACK FOOTER
// ./content/about/app-screenshots/results_following.png
// module id = 1300
// module chunks = 0